const apiUrl="https://api.technotiate.com.np"
export default apiUrl